<template>
	<div class="container__menuoptions">
		<i
			class="fas fa-bars container__menuoptions__hamburguer"
			@click="
				changeIsMenuHamburguerActive()
				cleanActiveSubmenuActive()
			"
		/>
		<img
			class="container__menuoptions__logo"
			src="../../../assets/treevia-logo.png"
		/>
		<MenuOptionsNavigation
			:menu-options="menuOptions"
			:is-menu-hamburguer-active="isMenuHamburguerActive"
			:clean-active-submenu-active="cleanActiveSubmenuActive"
			:change-menu-hamburguer-active="changeIsMenuHamburguerActive"
		/>
		<Backdrop
			:is-backdrop-actived="isMenuHamburguerActive"
			:click-optional-event="changeIsMenuHamburguerActive"
		/>
	</div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getIntegracoesDisponiveis } from '../../../services/requests/IntegracaoRequests'
import { getDashboardsCustomizados } from '../../../services/requests/DashBoardRequests'
import store from '../../../store/modules/moduleMessages'
import i18n from '../../../VueI18n'
import Backdrop from '../../Backdrop/Backdrop'
import MenuOptionsNavigation from '../MenuOptionsNavigation/MenuOptionsNavigation'

export default {
	components: { Backdrop, MenuOptionsNavigation },
	data() {
		return {
			/**
			 * Abre ou fecha o menu lateral quando clicado no hamburguer
			 */
			isMenuHamburguerActive: false,
		}
	},
	computed: {
		naoPossuiPrognoseContrado() {
			return !JSON.parse(localStorage.getItem('user-modules')).includes('PROGNOSE')
		},
		PossuiDashboardCustomizado() {
			return JSON.parse(localStorage.getItem('user-modules')).includes('DASHBOARD_CUSTOMIZADO')
		},

		PossuiPowerBI() {
			const possuiPowerBI = JSON.parse(localStorage.getItem('user-modules'))
			if (possuiPowerBI.includes('POWER_BI')) {
				return true
			} else {
				return false
			}
		},

		dadosHistoricosContratado() {
			return (
				JSON.parse(localStorage.getItem('user-modules')).includes('DEFAULT') ||
				JSON.parse(localStorage.getItem('user-modules')).includes('PROGNOSE')
			)
		},
		integracoesContratada() {
			return !JSON.parse(localStorage.getItem('user-modules')).includes('INTEGRACOES')
		},
		apiKeyContratada() {
			return !JSON.parse(localStorage.getItem('user-modules')).includes('API_KEY')
		},
		naoPossuiRiscoIncendioContratado() {
			return !JSON.parse(localStorage.getItem('user-modules')).includes('RISCO_INCENDIO')
		},
		/**
		 * Integracoes
		 */
		integracoesMenu() {
			return {
				menuItem: 'Integrações',
				loading: true,
				subItens: [
					{
						name: 'Integração SAP',
						link: 'integracao-SAP',
						subsistema: 'SAP',
						upgrade: this.integracoesContratada,
					},
					{
						name: this.$t('apiKeys'),
						link: 'apikey',
						upgrade: this.apiKeyContratada,
					},
				],
				subMenuActive: false,
			}
		},
		/**
		 * Opções do menu que deverão estar no navigation
		 */
		menuOptions() {
			var menu = [
				{
					menuItem: this.$t('home'),
					subItens: [
						{ name: 'Dashboard', link: 'dashboard' },
						{ name: 'Dashboard Analytics', link: 'analiseDetalhada' },
						{
							name: 'Dashboard Customizado',
							// link : "dashboardCustomizado" ,
							upgrade: !this.PossuiDashboardCustomizado,
							action: () => {
								this.getCustomizedReport()
							},
						},

						{
							name: 'Power BI View',
							upgrade: !this.PossuiPowerBI,
							isNew: true,
							action: () => {
								this.getPowerBI()
							},
						},
					],
				},
				{
					menuItem: this.$t('registry'),
					subItens: [
						{ name: this.$t('forest'), link: 'cadastroflorestal' },
						{ name: this.$t('inventory'), link: 'cadastroinventario' },
					],
					subMenuActive: false,
				},
				{
					menuItem: this.$t('planning'),
					subItens: [
						{ name: this.$t('serviceOrder'), link: 'ordemdeservico' },
						{ name: this.$t('collector'), link: 'coletor' },
						{ name: this.$t('cronogramaOrdemDeServico'), link: 'cronogramadeordemdeservico' },
					],
					subMenuActive: false,
				},
				{
					menuItem: this.$t('processing'),
					subItens: [
						{ name: this.$t('logging'), link: 'cubagem' },
						{ name: this.$t('forestInventory'), link: 'inventarioflorestal' },
						{ name: this.$t('qualityForestInventory'), link: 'inventarioQualidade' },
						{ name: this.$t('stackInventory'), link: 'inventarioPilhas' },
					],
					subMenuActive: false,
				},
				{
					menuItem: this.$t('prognosis'),
					upgrade: !JSON.parse(localStorage.getItem('user-modules')).includes('PROGNOSE'),
					subItens: [
						{
							name: this.$t('historicalData'),
							link: 'baseHistorica',
							upgrade: !this.dadosHistoricosContratado,
						},
						{
							name: this.$t('siteClassification'),
							link: 'classificacao',
							upgrade: this.naoPossuiPrognoseContrado,
						},
						{
							name: this.$t('prognosis'),
							link: 'prognose',
							upgrade: this.naoPossuiPrognoseContrado,
						},
						{
							name: this.$t('linkPrognosis'),
							link: 'vincular',
							upgrade: this.naoPossuiPrognoseContrado,
						},
					],
					subMenuActive: false,
				},

				{
					menuItem: this.$t('reports'),
					subItens: [
						{
							name: this.$t('forestInventory'),
							action: () => this.generateInventoryReport(true),
						},
						// {
						//   name: this.$t("qualityForestInventory"),
						//   link: 'relatorioinventarioflorestalqualidade'
						// },
						{
							name: this.$t('serviceOrder'),
							action: () => this.generateServiceOrderReport(true),
						},
						{
							name: this.$t('assortment'),
							action: () => this.generateAssortmentReport(true),
						},
					],
					subMenuActive: false,
				},
				{
					menuItem: this.$t('exports'),
					subItens: [
						{
							name: this.$t('treeInventory'),
							link: 'exportacaoinventarioarvore',
						},
						{
							name: this.$t('plotInventory'),
							link: 'exportarinventarioparcela',
						},
						{
							name: this.$t('sectionInventory'),
							link: 'exportacaoinventariotalhao',
						},
						{
							name: this.$t('stratumInventory'),
							link: 'exportacaoinventarioestrato',
						},

						{
							name: this.$t('compiledInventory'),
							link: 'inventariocompilado',
						},

						{
							name: this.$t('stackInventory'),
							link: 'exportacaoinventariopilha',
						},
						{
							name: this.$t('singleTreesInventory'),
							link: 'exportacaoinventariosingletrees',
						},

						{
							name: this.$t('qualityInventory'),
							link: 'inventarioqualidadexportacao',
						},
						{
							name: this.$t('exportPrognosisProjection'),
							link: 'exportacaovinculaprognose',
							upgrade: this.naoPossuiPrognoseContrado,
						},
						{
							name: this.$t('exportBetas'),
							link: 'exportacaobetas',
						},
					],
					subMenuActive: false,
				},
				this.integracoesMenu,
				{
					menuItem: 'Risco de Incêndio',
					upgrade: this.naoPossuiRiscoIncendioContratado,
					subItens: [
						{
							name: 'Dashboard',
							link: 'dashboard-fire-risk',
							upgrade: this.naoPossuiRiscoIncendioContratado,
						},
						{
							name: 'Cadastro de Zona de exclusão ',
							link: 'exclusion-zone',
							upgrade: this.naoPossuiRiscoIncendioContratado,
						},
						{
							name: 'Configurações',
							link: 'fire-risk-settings',
							upgrade: this.naoPossuiRiscoIncendioContratado,
						},
					],
					subMenuActive: false,
				},
				{
					menuItem: this.$t('settings'),
					subItens: [
						{
							name: this.$t('users'),
							link: 'usuarios',
						},
						{
							name: this.$t('accessProfile'),
							link: 'perfildeacesso',
						},
						{
							name: this.$t('appSettings'),
							link: 'configuracoesapp',
						},
					],
					subMenuActive: false,
				},
				{
					menuItem: this.$t('help'),
					subItens: [
						{ name: this.$t('support'), external: 'https://suporte.treevia.com.br/' },
						{ name: this.$t('changelog'), link: 'changelog' },
						{ name: this.$t('tutorial'), link: 'treeviaacademy' },
					],
					subMenuActive: false,
				},
			]

			return menu
		},
	},
	methods: {
		...mapMutations('moduleReports', [
			'generateInventoryReport',
			'generateServiceOrderReport',
			'generateAssortmentReport',
		]),
		/**
		 * Deixa todos os submenus desativados
		 */
		cleanActiveSubmenuActive() {
			this.menuOptions.forEach((item) => {
				item.subMenuActive = false
			})
		},
		/**
		 * Muda a condicao de quando o menu lateral está ou nao aberto
		 */
		changeIsMenuHamburguerActive() {
			this.isMenuHamburguerActive = !this.isMenuHamburguerActive
		},
		/**
		 * Trocar variavel que controla o menu hamburguer para false quando o tamanho
		 * da tela nao for para mobile
		 */
		handleWhenResize() {
			if (window.innerWidth > 992) {
				this.isMenuHamburguerActive = false
				this.cleanActiveSubmenuActive()
			}
		},

		async getCustomizedReport() {
			const userModules = JSON.parse(localStorage.getItem('user-modules'))

			if (!userModules.includes('DEFAULT') && !userModules.includes('DASHBOARD_CUSTOMIZADO')) {
				store.mutations.mutationShowMessage(store.state, {
					messageTitle: i18n.t('aviso'),
					messageText: i18n.t('avisoSemAcessoAoModulo'),
					messageIcon: 'fas fa-lock',
					messageType: 'warning',
				})
				return false
			}

			// O backend resolve quais dashboards o cliente tem (por customer_id). Sem mais
			// mapa hardcoded cliente->relatorio: consulta o registro (banco Power_BI_Reports).
			let dashboards = []
			try {
				const resposta = await getDashboardsCustomizados()
				dashboards = (resposta && resposta.data ? resposta.data : []).filter((d) => d.isActive)
			} catch {
				dashboards = []
			}

			if (!dashboards.length) {
				store.mutations.mutationShowMessage(store.state, {
					messageTitle: i18n.t('aviso'),
					messageText: i18n.t('avisoSemAcessoAoModulo'),
					messageIcon: 'fas fa-lock',
					messageType: 'warning',
				})
				return
			}

			// Abre o primeiro dashboard do cliente dentro do app (rota filha de Main.vue),
			// herdando o layout do sistema. O relatorio e renderizado num iframe (URL do blob).
			this.$router.push({
				name: 'dashboardCustomizado',
				params: { nome: dashboards[0].name },
			})
		},

		getPowerBI() {
			const possuiPowerBI = JSON.parse(localStorage.getItem('user-modules'))
			if (!possuiPowerBI.includes('POWER_BI')) {
				store.mutations.mutationShowMessage(store.state, {
					messageTitle: i18n.t('aviso'),
					messageText: i18n.t('avisoSemAcessoAoModulo'),
					messageIcon: 'fas fa-lock',
					messageType: 'warning',
				})
				return false
			} else {
				this.$router.push('/dashboardPowerBI')
			}
		},

		// Busca as integracoes que o usuario possui e adiciona elas
		recuperaEAdicionaNosRoutesAsIntegracoesDisponiveis() {
			getIntegracoesDisponiveis().then((response) => {
				const { result: integracoesDisponiveis } = response.data

				// Caso possua integracoes disponiveis percorre por elas adicionando um novo menu com seus subitens
				if (integracoesDisponiveis.length > 0) {
					this.integracoesMenu.loading = false
					this.configurarRotasDeIntegracao(integracoesDisponiveis)
					this.habilitarInterfaceParaAcessoAsIntegracoesDisponiveis(integracoesDisponiveis)
				}
			})
		},
		configurarRotasDeIntegracao(integracoesQueOClientePossui) {
			integracoesQueOClientePossui.forEach((integracao) => {
				const rota = this.$router
					.getRoutes()
					.find((rota) => rota.path === `/integracao-${integracao.subsistema}`)
				rota.props.default = Object.assign(rota.props.default, { urlIntegracao: integracao.url })
			})
		},
		habilitarInterfaceParaAcessoAsIntegracoesDisponiveis(integracoesQueOClientePossui) {
			integracoesQueOClientePossui.forEach((integracaoDoCliente) => {
				const subsistemaQueOClientePossui = integracaoDoCliente.subsistema
				const opcaoDoMenu = this.integracoesMenu.subItens.find(
					(subItem) => subItem.subsistema === subsistemaQueOClientePossui,
				)
				if (opcaoDoMenu) opcaoDoMenu.upgrade = false
			})
		},
		setarSeClientePrecisaFazerUpagraddeParaIntegracoes() {
			const userModules = JSON.parse(localStorage.getItem('user-modules'))
			const hasIntegracoes = userModules.includes('INTEGRACOES')
			const hasApiKey = userModules.includes('API_KEY')
			// Menu fica ativo se tiver INTEGRACOES OU API_KEY
			this.integracoesMenu.upgrade = !(hasIntegracoes || hasApiKey)
		},
	},
	created() {
		window.addEventListener('resize', this.handleWhenResize)
		this.setarSeClientePrecisaFazerUpagraddeParaIntegracoes()
		if (this.integracoesMenu.upgrade == false) {
			this.recuperaEAdicionaNosRoutesAsIntegracoesDisponiveis()
		}
	},
	destroyed() {
		window.removeEventListener('resize', this.handleWhenResize)
	},
}
</script>

<style scoped>
.container__menuoptions {
	padding: 0.5rem 0;
	display: flex;
	align-items: center;
}

.container__menuoptions__logo {
	display: none;
}

@media screen and (min-width: 992px) {
	.container__menuoptions {
		width: 100%;
		height: fit-content;
	}

	.container__menuoptions__hamburguer {
		display: none;
	}

	.container__menuoptions__logo {
		display: block;
		width: 27px;
		height: 20px;
	}
}
</style>
